<template>
    <div class="w-100 d-flex flex-column align-items-center">
        <PublicViewEvent
            :me="$store.state.me"
            :slug="$route.params.slug"
            :eventTicketsOn="eventsTicketsOn"
            class="w-100"
        />
        <!-- show button to list more events -->
        <CoButton
            variant="secondary"
            :label="$t('labels.eventsall')"
            class="my-4"
            @click="$router.push('/public/event-list')"
        />
    </div>
</template>

<script>
import PublicViewEvent from '@/components/Templates/User/Event/View/PublicEventView.vue';

export default {
    name: 'CoViewPublicEvent',
    components: {
        PublicViewEvent,
    },
    data() {
        return {
            eventsTicketsOn: this.$unleash.isEnabled('frontend.eventGuestTicketsOn'),
        };
    },
    created() {
        this.$unleash.on('ready', () => {
            if (this.$unleash.isEnabled('frontend.eventGuestTicketsOn')) {
                this.eventsTicketsOn = true;
            } else {
                this.eventsTicketsOn = false;
            }
        });
    },
};
</script>
